// import { appGetState, appNextState, appUpdateState } from "store";
// import { TUser, IUserListDimensions } from "models/User";
import { appGetState, appUpdateState } from "store";
import { IUserListDimensions } from "models/user/User";
// import { enableUser, resendInvite, resetPassword } from "api/UserApi";
// import { layoutService } from "services/LayoutService";
// import { catchRequestErrorMessage } from "utils/catchErrorUtils";
import { IDimension, ISetBucket, TBucket } from "models/Dimension";
import { updateBuckets } from "utils/dimensions/bucketUtils";

const comment = (m: string) => `UserService::${m}`;

class UserService {
  private appGetState = appGetState;
  // private appNextState = appNextState;
  private appUpdateState = appUpdateState;

  // create mutation for resendInvitation user
  // public resendInvitation = async (user: Partial<TUser>) => {
  //   const orgId = this.getCurrentOrg();
  //   try {
  //     const success = await resendInvite(user, orgId);
  //     if (success) {
  //       layoutService.addToast(`Resent Activation email to ${user.email}`, {
  //         theme: "success",
  //       });
  //     } else {
  //       layoutService.addToast(
  //         `There was an issue resending an invitation to ${user.email}`,
  //         {
  //           theme: "warning",
  //         }
  //       );
  //     }
  //   } catch (e) {
  //     layoutService.addToast(
  //       catchRequestErrorMessage(
  //         e,
  //         `There was an error resending an invitation to ${user.email}`
  //       ),
  //       {
  //         theme: "danger",
  //       }
  //     );
  //   }
  // };

  // create mutation for resetUserPassword user
  // public resetUserPassword = async (user: TUser) => {
  //   const orgId = this.getCurrentOrg();
  //   try {
  //     await resetPassword(user, orgId);
  //     layoutService.addToast(`Password Reset details sent to ${user.email}`, {
  //       theme: "success",
  //     });
  //     // this.clearList();
  //     // this.clearDictionary();
  //     // this.setUserDetails(newUser);
  //   } catch (e) {
  //     layoutService.addToast(
  //       catchRequestErrorMessage(
  //         e,
  //         `Error resetting password for ${user.email}`
  //       ),
  //       {
  //         theme: "danger",
  //       }
  //     );
  //   }
  // };

  // create mutation for enable/disable user
  // public enableUser = async (user: TUser, active: boolean) => {
  //   const orgId = this.getCurrentOrg();
  //   try {
  //     await enableUser(user, active, orgId);
  //     layoutService.addToast(
  //       `User successfully ${active ? "restored" : "suspended"}`,
  //       {
  //         theme: "success",
  //       }
  //     );
  //     // this.clearList();
  //     // this.setUserDetails(newUser);
  //   } catch (e) {
  //     layoutService.addToast(
  //       catchRequestErrorMessage(
  //         e,
  //         `Error ${active ? "suspending" : "restoring"} user`
  //       ),
  //       {
  //         theme: "danger",
  //       }
  //     );
  //   }
  // };

  public setDimensions = async ({ key, bucket }: ISetBucket) => {
    const currentDimensions = this.getCurrentDimensions();
    const dimension = currentDimensions[key];
    if (dimension) {
      window.logger.group(comment("setFilter"));
      await this.updateDimensionFilter({ bucket, dimension });
      // await this.loadList();
      window.logger.groupEnd();
    }
    return this.getCurrentDimensions();
  };

  public setManyDimensions = async (
    filters: (ISetBucket | undefined)[],
    refreshData?: boolean
  ) => {
    const currentDimensions = this.getCurrentDimensions();
    if (filters.length > 0) {
      window.logger.group(comment("setManyDimensions"));
      this.setIsLoading(true);
      for (let i = 0; i < filters.length; i++) {
        const f = filters[i];
        if (f) {
          const dimension = currentDimensions[f.key];
          const bucket = f.bucket === undefined ? null : f.bucket;
          await this.updateDimensionFilter({ bucket, dimension });
        }
      }
      this.setIsLoading(false);
      window.logger.groupEnd();
    }

    return this.getCurrentDimensions();
  };

  /**
   */
  private setIsLoading = (isLoading: boolean): void => {
    this.appUpdateState(
      (s) => (s.dimensions.isLoading = isLoading),
      comment("setIsLoading")
    );
  };

  private updateDimensionFilter = async ({
    bucket,
    dimension,
  }: {
    bucket?: TBucket | null;
    dimension?: IDimension;
  }) => {
    if (dimension) {
      const newBuckets = updateBuckets(bucket, dimension);
      this.appUpdateState(
        (s) =>
          (s.dimensions.users[dimension.key] = {
            ...dimension,
            buckets: newBuckets,
          }),
        comment("updateDimensionFilter")
      );
      return newBuckets;
    }
    return false;
  };

  private getCurrentDimensions = () => {
    const {
      dimensions: { users },
    } = this.appGetState();
    return users as IUserListDimensions;
  };
}

const userService = new UserService();
export { userService };
